import React from 'react';
import { useDispatch } from 'react-redux';
import { SET_MODAL } from 'constants';
import PropTypes from 'prop-types';
import { Button, Label, MenuItem, Select } from 'mw-style-react';
import useIntl from 'useIntl';
import mes from './intl';
import '../../ActorsFiltersPopup.scss';

function FilterSelect({
  filters,
  savedFilters,
  onChange,
  getSavedFilter,
  handleSubmitFilters,
  handleResetFilters,
}) {
  const t = useIntl();
  const dispatch = useDispatch();
  /**
   * Открытие модального окна для сохранения фильтра
   */
  const handleSaveFilter = () => {
    dispatch({
      type: SET_MODAL,
      payload: {
        name: 'SaveFilter',
        data: getSavedFilter(filters.filterId),
        callback: handleSubmitFilters,
      },
    });
  };

  /**
   * Открытие модального окна для удаления фильтра
   */
  const handleDeleteFilter = () => {
    dispatch({
      type: SET_MODAL,
      payload: {
        name: 'DeleteFilter',
        data: getSavedFilter(filters.filterId),
        callback: handleResetFilters,
      },
    });
  };
  return (
    <div styleName="filters__popup__content__section">
      <div styleName="filters__popup__content__row range">
        <div styleName="filters__popup__content__item">
          <Label value={t(mes.savedFilter)} />
          <Select
            id="savedFilterSelect"
            styleName="filters__popup__content__select openDown"
            type="autocomplete"
            size="medium"
            bordered={true}
            value={filters.name}
            helperText=""
            onChange={onChange}
          >
            {savedFilters.map((item) => (
              <MenuItem key={item.id} value={item} label={item.name} />
            ))}
          </Select>
        </div>
        <Button
          onClick={handleSaveFilter}
          type="text"
          size="small"
          styleName="filters__popup__content__btn__bottom"
          label={t(mes.buttonRenameFilter)}
          fontWeight="normal"
          icon="edit"
          iconAfter={null}
          filter={filters}
          visibility={filters.filterId ? 'visible' : 'hidden'}
        />
        <Button
          onClick={handleDeleteFilter}
          type="text"
          size="small"
          styleName="filters__popup__content__btn__bottom"
          label={t(mes.buttonDeleteFilter)}
          fontWeight="normal"
          icon="trash"
          iconAfter={null}
          filter={filters}
          visibility={filters.filterId ? 'visible' : 'hidden'}
        />
      </div>
    </div>
  );
}

FilterSelect.propTypes = {
  filters: PropTypes.object,
  savedFilters: PropTypes.array,
  onChange: PropTypes.func,
  getSavedFilter: PropTypes.func,
  handleSubmitFilters: PropTypes.func,
  handleResetFilters: PropTypes.func,
};

export default FilterSelect;
